import type {
  GenerationRecord,
  ImageDescriptor,
  ImageVariantResult,
  ProductImageGeneration,
} from '@/api/ProductImages/types';

export const generationVariantKey = (record: GenerationRecord) =>
  record.variantKey;

export const generationStyleMessage = (variantKey: string) => {
  switch (variantKey) {
    case 'outline':
      return 'imagery.style.outline';
    case 'studio-grey':
      return 'imagery.style.studio-grey';
    default:
      return undefined;
  }
};

export const generationOutput = (record: ProductImageGeneration) =>
  record.status === 'Succeeded' &&
  record.image?.assetId === record.id &&
  record.image.sourceRevisionId === record.sourceRevisionId &&
  record.image.variantKey === record.variantKey
    ? record.image
    : null;

export const matchingVariantGeneration = (
  image: ImageDescriptor,
  result: ImageVariantResult,
) =>
  image.sourceKind === 'Generated' &&
  result.generation?.sourceRevisionId === image.assetId &&
  result.generation.variantKey === result.variantKey
    ? result.generation
    : null;

export const activeVariantGeneration = (image?: ImageDescriptor | null) =>
  image?.variantResults.some((result) =>
    ['Queued', 'Pending', 'Running'].includes(
      matchingVariantGeneration(image, result)?.status ?? '',
    ),
  ) ?? false;

export const executableVariant = (variantKey: string) =>
  ['outline', 'studio-grey'].includes(variantKey);
